import React from 'react';
import { Card } from "react-bootstrap";
import face_image_1 from "../../assets/img/faceIstvanMiklos.png";
import face_image_2 from "../../assets/img/faceCsongorGedeon.jpg";
import ShowMoreText from "react-show-more-text";
import proj_image from "../../assets/img/projMiklosI_GedeonCs_burrow.png";

const I_Miklos_and_Cs_Gedeon_burrow = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}
        <Card.Img variant="top" src={proj_image} />
        <br />
        <Card.Body>
          <Card.Text class="d-flex justify-content-between card-text">
            {" "}

            <div style={{width: '183px'}}> {/* This is an ugly solution, but it works for now */}
            <img
              className="img2"
              src={face_image_1}
              
            />{" "}
            <p className="text7">István Miklós{" "}</p>
            <br />
            <p className="text8">
              Senior Research Fellow{" "}
            </p>
            </div>
            <div style={{width: '183px'}}>
            <img
              className="img2"
              src={face_image_2}
              
            />{" "}
            <p className="text7">Csongor Gedeon{" "}</p>
            <br />
            <p className="text8">
              Senior Research Associate{" "}
            </p>
            </div>
            
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            <p className="text8">Rényi Institute, HUN-REN </p>
            </div>
            <div>
            <p className="text8">Institute for Soil Sciences, HUN-REN ATK </p>
            </div>
            <div>
            Burrowing mammals act as ecosystem engineers, but their underground tunnels can also threaten structures such as dikes. 
            Several key burrowing species are endangered, and estimating their population sizes requires accurate, non-invasive methods.
            <br/>
            <br/>
            Since population size is strongly linked to the extent and structure of underground burrow networks, the project aims to 
            reconstruct these 3D systems from incomplete, indirect, and noisy measurements. Available data include surface maps of 
            burrow entrances, sparse ground-penetrating radar slices, and limited ground-truth excavations.
            <br/>
            <br/>
            The main challenge is to develop mathematical and statistical models that infer thin, anisotropic, spatially correlated 
            tunnel networks embedded in 3D soil, while incorporating environmental covariates and quantifying uncertainty.
            <br/>
            <br/>
            Possible approaches include spatial probabilistic models (e.g., point processes, Markov random fields, graph models), 
            learning directional growth rules, and Bayesian data assimilation combining surface and subsurface data.
            <br/>
            <br/>
            The outcome is a well-defined model and prototype implementation for 3D burrow reconstruction, with critical analysis of 
            assumptions and uncertainty. The focus is on principled mathematical modelling rather than black-box machine learning.
            <br/>
            <br/>
            The project is suitable for MSc students interested in probability, statistics, spatial modelling, inverse problems, or 
            applied mathematics, and offers close interaction with researchers at the Rényi Institute and other HUN-REN institutes.


            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default I_Miklos_and_Cs_Gedeon_burrow;